import {
  CheckboxVisibility,
  CommandBarButton,
  DetailsList,
  Dropdown,
  IColumn,
  Icon,
  IContextualMenuItem,
  IContextualMenuProps,
  IDetailsRowProps,
  IIconProps,
  Label,
  Pivot,
  PivotItem,
  PrimaryButton,
  SearchBox,
  Stack,
  Spinner,
  SpinnerSize,
  IconButton,
  mergeStyleSets,
} from '@fluentui/react';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import { NoDataFound } from '../../control/noDataFound';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import { DialogContext } from '../../context/dialog.context';
import ButtonMenuContext from '../../control/ButtonMenuContext';
import { commonfn } from '../../common/commonfn';
import { LeftMenuContext } from '../../context/leftMenu.context';
import { useHistory } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import ModaFilterMatrix from './modal/filter/modalFilterMatrix';
import ModalAddProducts from './modal/modalAddProducts';
import ModalUpdateDeadline from './modal/modalUpdateDeadline';
import { saveAs } from 'file-saver';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { useId } from '@fluentui/react-hooks';
import moment from 'moment';
import { css } from '@fluentui/react/lib/Utilities';

const UserApi = new Api.UserApi();
const MatrixApi = new Api.MatrixsApi();
const defaultFilter = {
  Year: new Date().getFullYear(),
  OrderBy: [
  ],
  PageSize: 1000,
  PageNumber: 1,
  ProductTypeId: 0,
  FilterItems: [
    {
      Name: 'ProductName',
      Value: '',
    },
  ],
  ReponsiveUserId: 0,
  SearchTypeEnum: Api.MatrixItemSearchTypeEnum.ProductName,
  Status: Api.MatrixItemStatusQueryEnum.All,
} as Api.GetPagedMatrixItemQuery;

const addIcon: IIconProps = { iconName: 'Settings' };

const chartOptions = {
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  responsive: true,
  maintainAspectRatio: true,
};

const calloutProps = { gapSpace: 0 };
// const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };
const classNames = mergeStyleSets({
  overflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 300,
  },
  overflow2: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 200,
  },
  // Just to look nice
  parent: {
    padding: 5,
  },
});

//const defaultMatrix
const Matrixs = () => {
  let routerHistory = useHistory();
  const tooltipId = useId('tooltip');
  const InfoIcon: IIconProps = { iconName: 'Info' };

  const parentTooltipId = useId('text-tooltip');
  const [isParentTooltipVisible, setIsParentTooltipVisible] = React.useState(false);

  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
  const { userTokenInfo } = useToken();
  const { t } = useTranslation();
  const FilterIcon: IIconProps = { iconName: 'Filter' };
  const lockIcon: IIconProps = { iconName: 'Lock', className: 'color-red' };
  const [isShowLoading, SetIsShowLoading] = React.useState(true);
  const [filter_cache, SetFilterCache] = React.useState('');
  const [FilterItem, SetFilterItem] = React.useState<Api.SearchTypeItem>({
    Name: Api.MatrixItemSearchTypeEnum.ProductName,
    Value: '',
  });
  const [IsOpenModalAddProducts, SetIsOpenModalAddProducts] = React.useState(false);
  const [isOpenModalFilter, SetIsOpenModalFilter] = React.useState(false);
  const [listProductType, setListProductType] = React.useState<Api.ProductType[]>([]);
  const [selectedKey, setSelectedKey] = React.useState<any>('');
  const [FilterQuery, setFilterQuery] = React.useState<Api.GetPagedMatrixItemQuery>(() => {
    var sParam = localStorage.getItem('MatrixFilterQueryCache');
    if (sParam) {
      var data = JSON.parse(sParam);
      setSelectedKey(data.ProductTypeId.toString());
      return data;
    } else {
      return { ...defaultFilter };
    }
  });
  const [listMaster, setListMaster] = React.useState<Api.MatrixItemDtoPaginatedResult | null>(null);
  const [listYears, setListYears] = React.useState<any[]>([]);
  const [matrixColumns, setMatrixColumns] = React.useState<IColumn[]>([]);
  const [currentMatrix, setCurrentMatrix] = React.useState<Api.Matrix>({});
  const searchFilters = [
    { key: Api.MatrixItemSearchTypeEnum.ProductName, text: t('Product') },
    { key: Api.MatrixItemSearchTypeEnum.ArticleNumber, text: t('ArticleNumber') },
    { key: Api.MatrixItemSearchTypeEnum.Gtin, text: 'GTIN' },
  ];
  const [isOpenModalUpdateDeadline, SetIsOpenModalUpdateDeadline] = React.useState(false);

  React.useEffect(() => {
    setFilterQuery({ ...FilterQuery, FilterItems: [FilterItem] });
  }, [FilterItem]);

  const [menuProps, SetMenuProps] = React.useState<IContextualMenuProps>({
    onDismiss: (ev) => {
      if (ev && 'shiftKey' in ev) {
        ev.preventDefault();
      }
    },
    items: [
      {
        key: 'export',
        text: 'Export',
      },
      {
        key: 'import',
        text: 'Import',
      },
    ],
  });
  let _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.MatrixItemDto) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Edit',
            text: t('ViewDetail'),
            onClick: (ev) => {
              routerHistory.push(
                '/matrix/detail/' +
                item.MatrixItemId +
                '?ProductType=' +
                FilterQuery.ProductTypeId +
                '&Page=' +
                FilterQuery.PageNumber +
                '&PageSize=' +
                FilterQuery.PageSize,
                { state: item },
              );
            },
          },
        ];
        if (userTokenInfo && userTokenInfo.Role !== 'Vendor' && !currentMatrix.IsLocked) {
          menuItems.push({
            key: 'Delete',
            text: t('RemoveFromMatrix'),
            onClick: (ev) => {
              setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
              setCallBackConfirmDialog({ action: deleteItem, param: item });
            },
          });
        }
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'Product.Name',
      name: t('Product'),
      className: 'flex-center',
      minWidth: 350,
      maxWidth: 350,
      // isResizable: true,
      onRender: (item: Api.MatrixItemDto) => {
        return <Stack horizontal>
          <div className={css(classNames.parent, classNames.overflow)}>
            <TooltipHost
              overflowMode={TooltipOverflowMode.Parent}
              content={item.Product?.Name ?? ''}
              onTooltipToggle={setIsParentTooltipVisible}
              id={parentTooltipId}
            >
              <span aria-describedby={isParentTooltipVisible ? parentTooltipId : undefined}>{item.Product?.Name}</span>
            </TooltipHost>
          </div>
          {!item.HaveSpecification && <TooltipHost
            content="No specification"
            id={tooltipId}
            calloutProps={calloutProps}
          >
            <IconButton styles={{
              root: {
                color: 'red',
              },
            }} iconProps={InfoIcon} aria-label="info" disabled={false} checked={false} />
          </TooltipHost>
          }
        </Stack>
      },
    },
    {
      key: 'Vendor',
      name: t('Vendor'),
      className: 'flex-center',
      minWidth: 200,
      isResizable: true,
      onRender: (item: Api.MatrixItemDto) => {
        return <div className={css(classNames.parent, classNames.overflow2)}>
          <TooltipHost
            overflowMode={TooltipOverflowMode.Parent}
            content={item.Product?.Vendor?.Name ?? ''}
            onTooltipToggle={setIsParentTooltipVisible}
            id={parentTooltipId}
          >
            <span aria-describedby={isParentTooltipVisible ? parentTooltipId : undefined}>{item.Product?.Vendor?.Name}</span>
          </TooltipHost>
        </div>
      },
      new: 1,
    },
    {
      key: 'Status',
      name: t('Status'),
      className: 'flex-center',
      minWidth: 100,
      onRender: (item: Api.MatrixItemDto) => {
        const dataChart = {
          labels: ['Complete', 'Remaining'],
          datasets: [
            {
              data: [
                item.TotalModuleApproved,
                parseInt(item.TotalModule as any) - parseInt(item.TotalModuleApproved as any),
              ],
              backgroundColor: ['#0aa252', '#D9D9D9'],
            },
          ],
        };
        return (
          <>
            {' '}
            <div className="chartBox">
              <Doughnut data={dataChart} options={chartOptions} />
            </div>
            &nbsp;{' '}
            <span>
              {item.TotalModuleApproved}/{item.TotalModule}
            </span>
          </>
        );
      },
    },
    {
      key: 'LastUpdated',
      name: t('LastUpdated'),
      className: 'flex-center',
      minWidth: 120,
      isResizable: true,
      onRender: (item: Api.MatrixItemDto) => {
        return item.LastUpdated === 0 ? "-" : moment((item.LastUpdated ?? 0) * 1000).format('DD/MM/yyyy HH:mm');
      },
    },
  ] as IColumn[];
  const matrixFixColumns = React.useRef<IColumn[]>(_columns);
  const deleteItem = async (item: Api.MatrixItemDto) => {
    let arr = [item.MatrixItemId || 0];
    await MatrixApi.apiMatrixsMatrixItemDelete(arr);
    SetFilterCache('');
    var sParam = localStorage.getItem('MatrixFilterQueryCache');
    if (sParam) {
      var data = JSON.parse(sParam);
      setFilterQuery({...FilterQuery, Year: data.Year, ProductTypeId: data.ProductTypeId});
    }
  };
  const getAllProductTypes = async () => {
    if (listProductType.length > 0) return;
    let data = (await UserApi.apiUserGetCurrentUserProductTypeGet()).data;
    setListProductType(data || []);
    if (data && data?.length > 0 && !FilterQuery.ProductTypeId) {
      setFilterQuery({
        ...FilterQuery, ProductTypeId: data[0].Id || 0
      })
    }
  };

  const getYears = async () => {
    if (listYears.length > 0) return;
    let years: any[] = [];
    commonfn.getListYears().forEach((element) => {
      years.push({ key: element, text: element.toString() });
    });
    setListYears(years);
  };

  const getStatus = (type: any) => {
    if (type === 'Null') {
      return '-';
    } else {
      return type;
    }
  };

  const handleSort = (sortKey: string, isDesc: boolean) => {
    // Create a new array to avoid mutating the state directly
    const sortedList = [...listMaster?.Data ?? []];

    // Sorting logic based on the chosen key and order
    switch (sortKey) {
      case 'Product.Name':
        sortedList.sort((a, b) => (isDesc ? (b.Product?.Name ?? '').localeCompare(a.Product?.Name ?? '')
          : (a.Product?.Name ?? '').localeCompare(b.Product?.Name ?? '')));
        break;
      case 'Vendor':
        sortedList.sort((a, b) => (isDesc ? (b.Product?.Vendor?.Name ?? '').localeCompare(a.Product?.Vendor?.Name ?? '')
          : (a.Product?.Vendor?.Name ?? '').localeCompare(b.Product?.Vendor?.Name ?? '')));
        break;
      case 'LastUpdated':
        sortedList.sort((a, b) => (isDesc ? (b.LastUpdated ?? 0) - (a.LastUpdated ?? 0)
          : (a.LastUpdated ?? 0) - (b.LastUpdated ?? 0)));
        break;
      case 'Status':
        sortedList.sort((a, b) => (isDesc ? (b.TotalModule ?? 0) - (a.TotalModule ?? 0)
          : (a.TotalModule ?? 0) - (b.TotalModule ?? 0)));
        sortedList.sort((a, b) => (isDesc ? (b.TotalModuleApproved ?? 0) / (b.TotalModule ?? 1) - (a.TotalModuleApproved ?? 0) / (a.TotalModule ?? 1)
          : (a.TotalModuleApproved ?? 0) / (a.TotalModule ?? 1) - (b.TotalModuleApproved ?? 0) / (b.TotalModule ?? 1)));
        break;
      default:
        break;
    }

    // Update the state with the sorted array
    setListMaster({ ...listMaster, Data: sortedList });
    SetIsShowLoading(false);
  };


  const getMatrixs = async () => {
    SetIsShowLoading(true);

    let data = (await MatrixApi.apiMatrixsPagedPost(FilterQuery)).data;
    setListMaster(data);
    if (data.Data?.length) {
      const temp = ((data.Data || []) as Api.MatrixItemDto[])[0].ModuleStatus;
      let moduleColumns: any[] = [];
      if (temp) {
        Object.keys(temp).forEach((element) => {
          moduleColumns.push({
            key: element,
            name: element,
            className: 'flex-center',
            maxWidth: 200,
            minWidth: 200,
            onRender: (item: Api.MatrixItemDto) => {
              const tmpStatus = (item.ModuleStatus as any)[element];
              if (!tmpStatus) {
                return <></>;
              } else {
                return (
                  <div className="flex-center">
                    <div style={{ marginRight: 6 }}>
                      {tmpStatus.Status === 'Approved' ? (
                        <Icon iconName="SkypeCircleCheck" className="Approved"></Icon>
                      ) : (
                        tmpStatus.Status !== 'Null' &&
                        (tmpStatus.Status === 'OverDue' ? (
                          <Icon iconName="Warning" className="OverDue"></Icon>
                        ) : tmpStatus.Status === 'OnGoing' ? (
                          <Icon iconName="Clock" className={'OnGoing'}></Icon>
                        ) : (
                          <Icon iconName="CircleHalfFull" className={'Pending'}></Icon>
                        ))
                      )}
                    </div>
                    <div>
                      <div>{t(getStatus(tmpStatus.Status))}</div>
                      <div style={{ fontSize: 12, color: 'gray' }}>
                        {tmpStatus.ReponsiveUser ? tmpStatus.ReponsiveUser.FullName : ''}
                      </div>
                    </div>
                  </div>
                );
              }
            },
          });
        });
      }
      setMatrixColumns([...matrixFixColumns.current, ...moduleColumns]);
    }
    await getMatrixStatus();
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };

  const lockMatrix = async (status: boolean) => {
    const param: Api.SetLockMatrixLockCommand = {
      ProductTypeId: FilterQuery.ProductTypeId,
      MatrixYear: FilterQuery.Year,
      IsLocked: status,
    };
    await MatrixApi.apiMatrixsSetLockPatch(param);
    getMatrixStatus();
  };

  const exportMatrix = () => {
    MatrixApi.apiMatrixsExportExcelPost(FilterQuery, {
      responseType: 'blob',
    }).then((response) => {
      saveAs((response as any).data as Blob);
    });
  };

  const getMatrixStatus = async () => {
    let data = (await MatrixApi.apiMatrixsGetMatrixByProductTypeAndYearGet(FilterQuery.ProductTypeId, FilterQuery.Year))
      .data.Data;
    if (data) {
      setCurrentMatrix(data);
      if (!data.IsLocked) {
        menuProps.items = [
          {
            key: 'export',
            text: t('Export'),
            onClick: () => {
              exportMatrix();
            },
          },
          {
            key: 'lock',
            text: t('Lock'),
            onClick: () => {
              setMsgConfirmDialog(t('AreYouSureYouWantToLockMatrix'));
              setCallBackConfirmDialog({ action: lockMatrix, param: true });
            },
          },
        ];
      } else {
        menuProps.items = [
          {
            key: 'unlock',
            text: 'Unlock',
            onClick: () => {
              setMsgConfirmDialog(t('AreYouSureYouWantToUnLockMatrix'));
              setCallBackConfirmDialog({ action: lockMatrix, param: false });
            },
          },
        ];
      }
      menuProps.items = [
        ...menuProps.items,
        {
          key: 'updateDeadline',
          text: t('UpdateDeadlines'),
          onClick: () => {
            SetIsOpenModalUpdateDeadline(true);
          },
        },
      ];
      SetMenuProps(menuProps);
    }
  };

  const _onColumnClick = (event: MouseEvent<HTMLElement> | undefined, column: IColumn | undefined) => {
    const sortColums = ['Product', 'Vendor', 'Status', 'Last updated'];
    if (sortColums.indexOf(column?.name || '') >= 0) {
      SetIsShowLoading(true);
      const newColumns: IColumn[] = matrixFixColumns.current.slice();
      const currColumn: IColumn = newColumns.filter((currCol) => column?.key === currCol.key)[0];
      newColumns.forEach((newCol: IColumn) => {
        if (newCol === currColumn) {
          currColumn.isSortedDescending = !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          newCol.isSorted = false;
          newCol.isSortedDescending = true;
        }
      });
      matrixFixColumns.current = newColumns;
      handleSort(column?.key ?? '', currColumn.isSortedDescending ?? false);
    }
  };
  React.useEffect(() => {
    getAllProductTypes();
    setSelectedMenuItem('Matrix');
    getYears();
  }, []);

  React.useEffect(() => {
    if (!FilterQuery.ProductTypeId) return;
    if(filter_cache === JSON.stringify(FilterQuery)) return;
    getMatrixs();
    localStorage.setItem('MatrixFilterQueryCache', JSON.stringify(FilterQuery));
    SetFilterCache(JSON.stringify(FilterQuery));
  }, [FilterQuery]);

  return (
    <div className="test matrix-page">
      <div className={'page-header'}>
        <Label>{t('Matrix')}</Label>
      </div>
      <Pivot
        className="tab-header"
        style={{ overflowY: 'hidden', overflowX: 'auto' }}
        selectedKey={selectedKey}
        onLinkClick={(item) => {
          setSelectedKey(item?.props.itemKey);
          setFilterQuery({ ...FilterQuery, ProductTypeId: parseInt(item?.props.itemKey || '0') });
        }}
      >
        {listProductType.map((item) => {
          return (
            <PivotItem key={item.Id} headerText={item.Name || ''} itemKey={(item.Id || '').toString()}></PivotItem>
          );
        })}
      </Pivot>

      <div className="page-content ms-Grid" dir="ltr">
        <div className="ms-Grid  form-list" dir="ltr">
          <div className="ms-Grid-row display-flex">
            <div className="ms-Grid-col padding-left-0 ms-md1" style={{ width: 100 }}>
              <Dropdown
                options={listYears}
                selectedKey={FilterQuery.Year}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, Year: newValue?.key as number});
                }}
              ></Dropdown>
            </div>
            {/* <div className="ms-Grid-col padding-left-0 ms-md1" style={{ width: 100 }}>
                        </div> */}
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ width: 430 }}>
              <Stack horizontal className="combieControl">
                <div>
                  {FilterQuery.FilterItems?.length && (
                    <Dropdown
                      options={searchFilters}
                      selectedKey={FilterItem.Name}
                      style={{ width: 130 }}
                      onChange={(e, newValue) => {
                        SetFilterItem({ ...FilterItem, Name: (newValue?.key as Api.MatrixItemSearchTypeEnum) || '' });
                      }}
                    ></Dropdown>
                  )}
                </div>
                <div style={{ minWidth: 300 }}>
                  <SearchBox
                    placeholder={t('Search')}
                    value={
                      FilterQuery.FilterItems && FilterQuery?.FilterItems[0]
                        ? FilterQuery?.FilterItems[0].Value ?? ''
                        : ''
                    }
                    showIcon={true}
                    onChange={(e, newValue) => {
                      SetFilterItem({ ...FilterItem, Value: newValue || '' });
                    }}
                  />
                </div>
                <div style={{ paddingTop: 6, marginLeft: 16 }}>
                  {isShowLoading && <Spinner size={SpinnerSize.medium} />}
                </div>
              </Stack>
            </div>
            <div className="ms-Grid-col ms-sm6">
              <Stack horizontal className="header-action">
                {currentMatrix.IsLocked && (
                  <CommandBarButton iconProps={lockIcon} text={''} className={'margin-left-auto'} onClick={() => { }} />
                )}
                &nbsp;
                <CommandBarButton
                  iconProps={FilterIcon}
                  text={t('Filter')}
                  className={'margin-left-auto'}
                  onClick={() => {
                    SetIsOpenModalFilter(true);
                  }}
                />
                &nbsp;
                {userTokenInfo && userTokenInfo.Role !== 'Vendor' && (
                  <CommandBarButton iconProps={addIcon} text={t('Tools')} menuProps={menuProps} />
                )}
                &nbsp; &nbsp;
                {userTokenInfo && userTokenInfo.Role !== 'Vendor' && !currentMatrix.IsLocked && (
                  <PrimaryButton
                    text={t('AddProducts')}
                    onClick={() => {
                      SetIsOpenModalAddProducts(true);
                    }}
                  />
                )}
              </Stack>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listMaster?.Data?.length || 0) > 0 && (
            <DetailsList
              items={listMaster?.Data || []}
              columns={matrixColumns}
              checkboxVisibility={CheckboxVisibility.hidden}
              onColumnHeaderClick={_onColumnClick}
              onRenderRow={(props) => {
                return _renderRow(props || ({} as IDetailsRowProps), () => {
                  routerHistory.push(
                    '/matrix/detail/' +
                    props?.item.MatrixItemId +
                    '?ProductType=' +
                    FilterQuery.ProductTypeId +
                    '&Page=' +
                    FilterQuery.PageNumber +
                    '&PageSize=' +
                    FilterQuery.PageSize,
                    { state: props?.item },
                  );
                });
              }}
            />
          )}
          <NoDataFound isShow={(listMaster?.Data?.length ?? 0) === 0}></NoDataFound>
        </div>
        <ModaFilterMatrix
          ProductTypeId={FilterQuery.ProductTypeId || 0}
          IsOpen={isOpenModalFilter}
          FilterItem={FilterQuery}
          onCloseModal={() => {
            SetIsOpenModalFilter(false);
          }}
          onOkClick={(filterItem) => {
            setFilterQuery({ ...filterItem });
            SetIsOpenModalFilter(false);
          }}
        ></ModaFilterMatrix>
        {IsOpenModalAddProducts && (
          <ModalAddProducts
            IsOpen={IsOpenModalAddProducts}
            ProductTypeId={FilterQuery.ProductTypeId || 0}
            Year={FilterQuery.Year || 2021}
            onSaveClick={() => {
              SetFilterCache('');
              setFilterQuery({...FilterQuery});
            }}
            onCloseModal={() => {
              SetIsOpenModalAddProducts(false);
            }}
          ></ModalAddProducts>
        )}
        {isOpenModalUpdateDeadline && (
          <ModalUpdateDeadline
            Year={FilterQuery.Year || 0}
            IsOpen={isOpenModalUpdateDeadline}
            onCloseModal={() => {
              SetIsOpenModalUpdateDeadline(false);
            }}
            onSaveClick={() => {
              SetFilterCache('');
              setFilterQuery({...FilterQuery});
            }}
            ProductTypeId={FilterQuery.ProductTypeId || 1}
          ></ModalUpdateDeadline>
        )}
      </div>
    </div>
  );
};
export default Matrixs;
